import styled from "styled-components";

export const ToolTipDetailsWrapper = styled.div<{ isMROFlow: boolean }>(({ isMROFlow = false }) => ({
    maxHeight: isMROFlow ? "300px" : "none",
    overflowY: isMROFlow ? "scroll" : "visible",

    ...(isMROFlow && {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    }),
}));
